exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-main{display:flex;flex:1 0 auto;max-width:100%;transition:.2s cubic-bezier(0.4, 0, 0.2, 1)}.v-main:not([data-booted=true]){transition:none !important}.v-main__wrap{flex:1 1 auto;max-width:100%;position:relative}@-moz-document url-prefix(){@media print{.v-main{display:block}}}", ""]);

// exports
